import { render, staticRenderFns } from "./BotonHistorialEstadosAcademicos.vue?vue&type=template&id=84c22ca8"
import script from "./BotonHistorialEstadosAcademicos.vue?vue&type=script&lang=js"
export * from "./BotonHistorialEstadosAcademicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports